'use strict';

/* $ */
/* global _ */
/* global Backbone */
/* Marionette */

import { CalculatorBarModel, CalculatorBar } from './bar';

let basketRadio = Backbone.Radio.channel('basket');
/**
 * Модель для хранения модели данных бруска
 */
class CalculatorCanopyModel extends CalculatorBarModel {
    initialize(){
        let self = this;

        this.set('count', parseFloat(this.get('default_count')));
        this.set('can_add_to_basket', this.get('count') > 0);

        self.listenTo(basketRadio, 'calculator:in:basket', self.checkCalculatorIsAdded);

        self.listenTo(self, 'change:bar_length change:bar_width change:bar_species change:bar_grade', self.calculateBarPrice);

        self.listenTo(self, 'change:count change:bar_volume', self.calculateVolume);
        self.listenTo(self, 'change:count change:price', self.calculateSumm);
        self.listenTo(self, 'change:count change:price_id', self.checkCanAddToBasket);

        self.processData();
    }
    // Приведем все числа к дробным, чтобы не запутаться в расчетах
    processData() {
        let self = this;
        let dict = self.get('dict');
        let data = self.get('data');

        _.each(data, function(item){
            _.each(dict, function(elem){
                if(_.includes(['width','length_min','length_max','height', 'price'], elem)){
                    item[elem] = parseFloat(item[elem]);
                }
            });
        });


        self.set('data', data, { silent: true });
    }
    calculateBarPrice(){
        let self = this;

        let bar_length = self.get('bar_length');
        let bar_width = self.get('bar_width');
        let bar_height = self.get('bar_height');
        let species =  self.get('bar_species');
        let grade = self.get('bar_grade');
        let data = self.get('data');

        let price_item = _.find(data, function(item){
            return ((item.width == bar_width) && (bar_length <= item.length_max) && (bar_length >= item.length_min) && (item.species == species) && (item.grade == grade)) ? true : false;
        });

        let price = 0;
        let price_id = 0;
        if(!_.isUndefined(price_item)){
            price = price_item.price;
            price_id = price_item.n;
        }

        // console.log(bar_width, bar_height, bar_length);
        // Переведем мм3 в м3
        let volume = (bar_width / 1000) * (bar_height / 1000) * (bar_length / 1000);
        // console.log('bar_volume', volume);
        volume = Math.floor(volume * 10000) / 10000; // округлим, чтобы подровнять округление js
        self.set('bar_volume', volume);

        self.set('price_id', price_id);
        self.set('price', price * bar_length / 1000);
    }
}

/**
 * Контроллер для калькулятора бруска
 */
class CalculatorCanopy extends CalculatorBar {
    paramsCollectionChanged(){
        let self = this;
        let params = self.params_collection.getParams();

        self.model.set({
            'bar_length': params['length'],
            'bar_width': params['width'],
            'bar_height': params['height'],
            'bar_species': params['species'],
            'bar_grade': params['grade'],
        });
    }
}

export {
    CalculatorCanopyModel,
    CalculatorCanopy
};

